import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	allIssues: {
		id: 'software-deployments.timeline.issue-page-fetcher.loading-status-indicator.all-issues',
		defaultMessage:
			'Showing {issuesCount} {issuesCount, plural, one {issue} other {issues}} that match your settings or filters.',
		description: 'Message that indicates all issues are being shown',
	},
	maxIssues: {
		id: 'software-deployments.timeline.issue-page-fetcher.loading-status-indicator.max-issues',
		defaultMessage:
			'Displaying maximum number of issues. Please add some filters to refine your search.',
		description: 'Message that indicates max issues are shown',
	},
});
